import {RemoteGetCheckRequestProtocol} from 'data/usecases';
import {GetCheckRequestProtocol} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetCheckRequestProtocol = (): GetCheckRequestProtocol =>
	new RemoteGetCheckRequestProtocol(
		makeBFFApiUrl(RefundFlowEndPoints.checkRequestProtocol),
		makeAuthorizeHttpClientDecorator(),
	);
